<template>
  <div class="mh_homepage">
    <homeBanner />
    <div class="mh-block1">
      <div class="block1-title">
        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/title1.png" />
      </div>
      <div class="block1-content">
        <div
          class="block1-item"
          v-for="(item,index) in systemList"
          :key="index"
        >
          <img :src="item.imgurl" />
          <div>{{item.text}}</div>
        </div>
      </div>
    </div>
    <div class="mh-block2">
      <div class="block2-title">
        <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/title2.png" />
      </div>
      <div class="block2-content">
        <div
          class="block2-item"
          v-for="(item,index) in gnList"
          :key="index"
        >
          <img :src="item.imgurl" />
          <div>{{item.text}}</div>
        </div>
      </div>
    </div>
    <div class="mh-block3">
      <div class="block3-box">
        <div class="block3-left">
          <div class="block3-logo">
            <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/logo.png" />
          </div>
          <div class="block3-title">咚咚燕助手</div>
          <div class="block3-text">咚咚燕助手APP功能全面而易用，能够满足几乎所有家政公司的日常需求，提效率，降成本，就是这么简单。面向不同规模的家政公司，提供完整健全的SaaS家政管理工具，帮助家政企业降低运营成本促进快速发展。</div>
          <div class="block3-code">
            <div class="h5qrcode_box">
                <div class="app_qrcode_wrap">
                  <div id="appQrcode">

                  </div>
                </div>
                <span class="txt">扫码下载咚咚燕APP</span>
            </div>
            <!-- <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/code2.png" /> -->
          </div>
        </div>
        <div class="block3-right">
          <img src="https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mh-bg-phone3.png" />
        </div>
        
      </div>
    </div>
    <footers />
  </div>
</template>

<script>
import homeBanner from "../block/front/homeBanner.vue";
import footers from "../block/front/footers.vue";
import QRCode from "qrcodejs2";
export default {
  name: "mh_homepage",
  show: true,
  components: {
    footers,
    homeBanner
  },
  data() {
    return {
      systemList: [
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block1.png",
          text:
            "客户维护、阿姨匹配、在线合同签署，业务流程可视透明，提高家政公司工作效率。"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block2.png",
          text:
            "全面接入信用管理系统，整合权威第三方信用数据，快速查询家政员信用。"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block3.png",
          text:
            "课程推广奖励、培训课程奖励、保险奖励，帮助家政公司拓宽收益渠道。"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block4.png",
          text:
            "整合培训系统，将培训纳入业务管理，培训日常化，考试获证，上岗工作有条不紊。"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block5.png",
          text:
            "整合丰富的社交媒体营销工具，如微网站、海报、热文推广等功能，帮助家政公司0成本拉新获客。"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/block6.png",
          text:
            "支持完整的电子合同签订、线上投保、三方面试等功能，加速商机落地。"
        }
      ],
      gnList: [
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon1.png",
          text: "家政员管理"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon2.png",
          text: "上门证培训"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon3.png",
          text: "政府平台对接"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon4.png",
          text: "招聘家政员"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon5.png",
          text: "三方远程面试"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon6.png",
          text: "客户管理"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon7.png",
          text: "商业保险"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon8.png",
          text: "热文推广"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon9.png",
          text: "微店铺"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon10.png",
          text: "宣传海报"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon11.png",
          text: "订单管理"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon12.png",
          text: "店铺名片"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon13.png",
          text: "员工管理"
        },
        {
          imgurl:
            "https://wd-appdownload.oss-cn-beijing.aliyuncs.com/wdn-saas-pc/sdjzmh/mhicon14.png",
          text: "电子网签"
        }
      ],
      appQRCode: null,
    };
  },
  mounted() {
    localStorage.setItem("loginBy", 0);
    this.$nextTick(() => {
        this.appQrcodeFn()
    })
  },
  methods: {
     async appQrcodeFn() {
      if (this.appQRCode) return;
      this.appQRCode = new QRCode("appQrcode", {
        width: 120,
        height: 120, // 高度
        text: `${location.origin}/appDownload`, // 二维码内容
        display: "none"
        // render: 'canvas' ,   // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
        // background: '#f0f',   // 背景色
        // foreground: '#ff0'    // 前景色
      });
    }
  }
};
</script>
<style lang="stylus" scoped>
@import '../asset/css/mhHomepage.styl';
</style>
